import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'fin-date',
  templateUrl: './date.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DateComponent {
  date = input(0);
  text = input('');
}
